module.exports = __webpack_public_path__ + "static/media/website-templets-img-2.11beacf6.png";